// extracted by mini-css-extract-plugin
module.exports = {"qs-search_element--disabled":"lLRsl","pagination":"LaqBf","pagination__item":"sSbD+","pagination__item--active":"qUdYC","pagination__link":"N222a"};